import { createSelector } from '@reduxjs/toolkit';
import { getStartOpen } from '../operators/getStartOpen';
import { getWidgetUiState } from '../../selectors/getWidgetUiState';
export const getWidgetStartOpen = createSelector([getWidgetUiState], widgetUiState => getStartOpen(widgetUiState));